import React, { Dispatch, SetStateAction } from 'react';
import Image from 'next/legacy/image';
import shadowImage from '@assets/images/shadow-image.svg';
import checkCircle from '@assets/images/check-circle.gif';
import Popup from '../Popup/Popup';

type Props = {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
};

export default function AddedToCartPopup({ isOpen, setIsOpen }: Props) {
  return (
    <Popup delay={2000} isOpen={isOpen} setIsOpen={setIsOpen}>
      <div className="flex items-center flex-col">
        <div className="relative h-16 w-16 flex justify-center items-center pb-20">
          <div className="transform h-12 w-12 absolute">
            <Image objectFit="fill" src={shadowImage} alt="shadow-image" />
          </div>
          <div className="relative h-24 w-24 flex justify-center items-center">
            <Image objectFit="fill" src={checkCircle} alt="check-circle" />
          </div>
        </div>
        <p className="text-28 font-rp-pn-regular -mb-10">Item added to cart</p>
      </div>
    </Popup>
  );
}
